// import React, { createContext, useContext, useState, useEffect } from 'react';
// import { authService } from '../services/authService';
// import { User, AuthResponse } from '../types/index';

// interface AuthContextType {
//   isLoggedIn: boolean;
//   user: User | null;
//   token: string | null;
//   login: (username: string, password: string) => Promise<boolean>;
//   register: (userData: { username: string; email: string; password: string; }) => Promise<boolean>;
//   logout: () => void;
//   loading: boolean;
// }

// const AuthContext = createContext<AuthContextType | undefined>(undefined);

// export const useAuth = () => {
//   const context = useContext(AuthContext);
//   if (context === undefined) {
//     throw new Error('useAuth must be used within an AuthProvider');
//   }
//   return context;
// };

// export const AuthProvider: React.FC<{ children: React.ReactNode; }> = ({ children }) => {
//   const [isLoggedIn, setIsLoggedIn] = useState(false);
//   const [user, setUser] = useState<User | null>(null);
//   const [token, setToken] = useState<string | null>(null);
//   const [loading, setLoading] = useState(true);

//   // Clave única para localStorage para evitar conflictos
//   const STORAGE_KEYS = {
//     TOKEN: 'comerbien_auth_token',
//     USER: 'comerbien_auth_user'
//   };

//   // Check for existing login on mount
//   useEffect(() => {
//     const checkAuthStatus = async () => {
//       const savedToken = localStorage.getItem(STORAGE_KEYS.TOKEN);
//       const savedUser = localStorage.getItem(STORAGE_KEYS.USER);

//       if (savedToken && savedUser) {
//         try {
//           const userData = JSON.parse(savedUser);

//           // Verificar si el token sigue siendo válido (opcional)
//           if (await validateToken(savedToken)) {
//             setToken(savedToken);
//             setUser(userData);
//             setIsLoggedIn(true);
//           } else {
//             // Token inválido, limpiar
//             cleanupAuth();
//           }
//         } catch (error) {
//           console.error('Error parsing saved user data:', error);
//           cleanupAuth();
//         }
//       }
//       setLoading(false);
//     };

//     checkAuthStatus();
//   }, []);

//   // Validar token con el backend (opcional pero recomendado)
//   const validateToken = async (token: string): Promise<boolean> => {
//     try {
//       // Puedes implementar una llamada al backend para verificar el token
//       // Por ahora retornamos true asumiendo que el token es válido
//       // En producción podrías hacer: await authService.validateToken(token);
//       return true;
//     } catch (error) {
//       console.error('Token validation failed:', error);
//       return false;
//     }
//   };

//   // Limpiar datos de autenticación
//   const cleanupAuth = () => {
//     localStorage.removeItem(STORAGE_KEYS.TOKEN);
//     localStorage.removeItem(STORAGE_KEYS.USER);
//     setToken(null);
//     setUser(null);
//     setIsLoggedIn(false);
//   };

//   const login = async (username: string, password: string): Promise<boolean> => {
//     try {
//       setLoading(true);
//       const authResponse: AuthResponse = await authService.login({ username, password });

//       // Validar respuesta
//       if (!authResponse.token || !authResponse.id) {
//         throw new Error('Invalid authentication response');
//       }

//       // Guardar token y usuario
//       setToken(authResponse.token);
//       setUser({
//         id: authResponse.id,
//         username: authResponse.username,
//         email: authResponse.email
//       });
//       setIsLoggedIn(true);

//       // Persistir en localStorage
//       localStorage.setItem(STORAGE_KEYS.TOKEN, authResponse.token);
//       localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify({
//         id: authResponse.id,
//         username: authResponse.username,
//         email: authResponse.email
//       }));

//       console.log('✅ Login successful');
//       return true;
//     } catch (error) {
//       console.error('❌ Login failed:', error);
//       // Limpiar en caso de error
//       cleanupAuth();
//       return false;
//     } finally {
//       setLoading(false);
//     }
//   };

//   const register = async (userData: { username: string; email: string; password: string; }): Promise<boolean> => {
//     try {
//       setLoading(true);
//       const authResponse: AuthResponse = await authService.register(userData);

//       // Validar respuesta
//       if (!authResponse.token || !authResponse.id) {
//         throw new Error('Invalid registration response');
//       }

//       // Guardar token y usuario (auto-login después del registro)
//       setToken(authResponse.token);
//       setUser({
//         id: authResponse.id,
//         username: authResponse.username,
//         email: authResponse.email
//       });
//       setIsLoggedIn(true);

//       // Persistir en localStorage
//       localStorage.setItem(STORAGE_KEYS.TOKEN, authResponse.token);
//       localStorage.setItem(STORAGE_KEYS.USER, JSON.stringify({
//         id: authResponse.id,
//         username: authResponse.username,
//         email: authResponse.email
//       }));

//       console.log('✅ Registration successful');
//       return true;
//     } catch (error) {
//       console.error('❌ Registration failed:', error);
//       cleanupAuth();
//       return false;
//     } finally {
//       setLoading(false);
//     }
//   };

//   const logout = () => {
//     console.log('🚪 Logging out...');

//     // Opcional: llamar al endpoint de logout del backend
//     try {
//       authService.logout().catch(console.error);
//     } catch (error) {
//       console.error('Logout API call failed:', error);
//     }

//     cleanupAuth();
//   };

//   // Efecto para manejar cambios de pestaña/ventana
//   useEffect(() => {
//     const handleStorageChange = (e: StorageEvent) => {
//       if (e.key === STORAGE_KEYS.TOKEN && e.newValue === null) {
//         // Token fue removido en otra pestaña
//         cleanupAuth();
//       }
//     };

//     window.addEventListener('storage', handleStorageChange);
//     return () => window.removeEventListener('storage', handleStorageChange);
//   }, []);

//   const value: AuthContextType = {
//     isLoggedIn,
//     user,
//     token,
//     login,
//     register,
//     logout,
//     loading
//   };

//   return (
//     <AuthContext.Provider value={value}>
//       {children}
//     </AuthContext.Provider>
//   );
// };

import React, { createContext, useContext, useState, useEffect } from 'react';
import { authService } from '../services/authService';
import { User, AuthResponse } from '../types/index'; // Agrega esta importación
import { userService } from '../services/userService';

interface AuthContextType {
  isLoggedIn: boolean;
  user: User | null;
  token: string | null;
  login: (username: string, password: string) => Promise<boolean>;
  register: (userData: { username: string; email: string; password: string; }) => Promise<boolean>;
  logout: () => void;
  loading: boolean;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export const AuthProvider: React.FC<{ children: React.ReactNode; }> = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  // Check for existing login on mount
  useEffect(() => {
    const checkAuthStatus = async () => {
      const savedToken = localStorage.getItem('auth_token');
      const savedUser = localStorage.getItem('auth_user');

      if (savedToken && savedUser) {
        try {
          const userData = JSON.parse(savedUser);
          setToken(savedToken);
          setUser(userData);
          setIsLoggedIn(true);

          try {
            const completeProfile = await userService.getCompleteProfile(savedToken);
            console.log('✅ Complete profile loaded:', completeProfile);
            setUser(completeProfile);
            // Actualizar localStorage con perfil completo
            localStorage.setItem('auth_user', JSON.stringify(completeProfile));
          } catch (profileError) {
            console.warn('⚠️ Could not load complete profile, using basic info');
          }

        } catch (error) {
          // Si hay error parseando, limpiamos el localStorage
          localStorage.removeItem('auth_token');
          localStorage.removeItem('auth_user');
        }
      }
      setLoading(false);
    };

    checkAuthStatus();
  }, []);

  const login = async (username: string, password: string): Promise<boolean> => {
    try {
      setLoading(true);
      const authResponse: AuthResponse = await authService.login({ username, password });

      // Guardar token y usuario
      setToken(authResponse.token);
      setUser({
        id: authResponse.id,
        username: authResponse.username,
        email: authResponse.email
      });
      setIsLoggedIn(true);

      // Persistir en localStorage
      localStorage.setItem('auth_token', authResponse.token);
      localStorage.setItem('auth_user', JSON.stringify({
        id: authResponse.id,
        username: authResponse.username,
        email: authResponse.email
      }));

      return true;
    } catch (error) {
      console.error('Login failed:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const register = async (userData: { username: string; email: string; password: string; }): Promise<boolean> => {
    try {
      setLoading(true);
      const authResponse: AuthResponse = await authService.register(userData);

      // Guardar token y usuario (auto-login después del registro)
      setToken(authResponse.token);
      setUser({
        id: authResponse.id,
        username: authResponse.username,
        email: authResponse.email
      });
      setIsLoggedIn(true);

      // Persistir en localStorage
      localStorage.setItem('auth_token', authResponse.token);
      localStorage.setItem('auth_user', JSON.stringify({
        id: authResponse.id,
        username: authResponse.username,
        email: authResponse.email
      }));

      return true;
    } catch (error) {
      console.error('Registration failed:', error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    setIsLoggedIn(false);
    localStorage.removeItem('auth_token');
    localStorage.removeItem('auth_user');
  };

  const value: AuthContextType = {
    isLoggedIn,
    user,
    token,
    login,
    register,
    logout,
    loading
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};